export default "__VITE_ASSET__BL74__$P__"